module.exports = __webpack_public_path__ + "static/media/ks_shack_background_tablet_sm.1d0932a1.jpg";